const home = {
  hero: {
    title: '红桃视频在线观看',
    subtitle: '免费高清视频播放平台',
    description: '海量高清视频资源，无需下载即点即播。支持手机、平板、电脑多端畅看，每日更新，体验流畅。',
    cta: '开始观看',
    stats: {
      videos: '10万+',
      videosLabel: '视频资源',
      daily: '500+',
      dailyLabel: '每日更新',
      users: '1000万+',
      usersLabel: '活跃用户',
    },
  },
  categoryNav: {
    title: '热门分类',
    subtitle: '探索您感兴趣的视频内容',
  },
  featured: {
    title: '精选推荐',
    subtitle: '编辑精心挑选的高品质视频内容',
    watchNow: '立即观看',
  },
  latest: {
    title: '最新更新',
    subtitle: '每日更新的最新视频内容',
    viewAll: '查看全部',
  },
  faq: {
    title: '常见问题',
    subtitle: '关于红桃视频在线观看的常见疑问',
    questions: [
      {
        q: '红桃视频在线观看需要下载吗？',
        a: '不需要下载任何软件或APP。红桃视频在线观看支持即点即播，直接在浏览器中观看高清视频，无论是手机、平板还是电脑，都能流畅体验。',
      },
      {
        q: '红桃视频在线观看是否免费？',
        a: '是的，红桃视频在线观看对所有用户完全免费。我们提供海量高清视频资源，无需付费即可观看，致力于让每一位用户都能享受优质的观影体验。',
      },
      {
        q: '红桃视频在线观看支持哪些设备？',
        a: '红桃视频在线观看全面支持手机、平板和电脑等多终端设备。无论您使用iOS、Android、Windows还是Mac系统，只需打开浏览器即可畅享高清视频。',
      },
      {
        q: '红桃视频在线观看的视频更新频率如何？',
        a: '红桃视频在线观看每日更新，每天都有大量新内容上线。我们的编辑团队持续筛选优质视频资源，确保您总能看到最新、最热的视频内容。',
      },
      {
        q: '在红桃视频在线观看上如何找到想看的视频？',
        a: '您可以通过首页的分类导航浏览不同类别的视频，也可以使用搜索功能直接查找您感兴趣的内容。我们提供了电影、电视剧、综艺、动漫、纪录片等多种分类供您选择。',
      },
    ],
  },
  cta: {
    title: '立即开始您的观影之旅',
    subtitle: '加入红桃视频在线观看，畅享海量高清视频资源',
    button: '免费观看',
  },
};

export default home;